module.exports = "/_next/static/images/payments_1-61c8c59765dbbc94edf5644502175e1c.png";